import React, { forwardRef, ReactNode } from 'react';

import clsx from 'clsx';

import styles from './Button.module.scss';
import ButtonLoader, { ButtonLoaderVariant } from './ButtonLoader/ButtonLoader';

type ButtonVariant = 'default' | 'underline' | 'link' | 'white';

interface ButtonProps {
  children: string | ReactNode;
  className?: string;
  disabled?: boolean;
  variant?: ButtonVariant;
  active?: boolean;
  isLoading?: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

const variantClasses: Record<ButtonVariant, string> = {
  default: styles.buttonDefault,
  underline: styles.buttonUnderline,
  link: styles.buttonLink,
  white: styles.buttonWhite,
};

const loaderVariantMap: Record<ButtonVariant, ButtonLoaderVariant> = {
  default: 'primary',
  underline: 'dark',
  link: 'primary',
  white: 'white',
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, disabled = false, variant = 'default', active, isLoading = false, onClick }, ref) => {
    const handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
      if (disabled) {
        return;
      }

      onClick(event);
    };

    return (
      <button
        ref={ref}
        className={clsx(
          className,
          isLoading && styles.buttonLoading,
          styles.button,
          variantClasses[variant],
          active && styles.active,
          disabled && styles.disabled,
        )}
        onClick={handleOnClick}
        disabled={isLoading || disabled}
      >
        {isLoading ? <ButtonLoader className={styles.buttonLoader} variant={loaderVariantMap[variant]} /> : children}
      </button>
    );
  },
);

export default Button;
